import { render, staticRenderFns } from "./WaterQuality.vue?vue&type=template&id=af2f6ab6&"
import script from "./WaterQuality.vue?vue&type=script&lang=js&"
export * from "./WaterQuality.vue?vue&type=script&lang=js&"
import style0 from "./WaterQuality.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports